import { IButtonProps as ISrButtonProps } from "@starrez/starryui9";

export * from "./Button";

export interface IButtonProps extends ISrButtonProps {
    showAsEnabled?: boolean;
}

export interface IButtonDivStyleProps {
    showAsEnabled?: boolean;
}
